const getFlexProperty = property => {
  if (property === 'flexStart') return 'flex-start'
  if (property === 'flexEnd') return 'flex-end'
  if (property === 'center') return 'center'
  if (property === 'column') return 'column'
  if (property === 'row') return 'row'
  return ''
}
export default getFlexProperty
